// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import { css } from '@linaria/core';
import { themeCssVar as globalTheme } from '../../utils/theme';

export const theme = {
  fontFamily: globalTheme.fontSize.body1Regular,
  fontSize: globalTheme.fontSize.body1Regular,
  fontWeight: globalTheme.fontWeight.body1Regular,
  lineHeight: globalTheme.lineHeight.body1Regular,
  label: globalTheme.color.textFormLabelDefault,
  value: globalTheme.color.textFormHelpDefault,
  handle: globalTheme.color.backgroundSliderDefaultKnobEnabled,
  handleDisabled: globalTheme.color.backgroundSliderDefaultKnobDisabled,
  handleBorder: globalTheme.color.borderSliderDefaultKnobEnabled,
  handleBorderDisabled: globalTheme.color.borderSliderDefaultKnobDisabled,
  hover: globalTheme.color.borderBrand,
  fill: globalTheme.color.interactiveButtonSecondary,
  focus: globalTheme.color.borderFocusDefault,
  track: globalTheme.color.backgroundSliderDefaultFillEnabled,
  trackDisabled: globalTheme.color.backgroundSliderDefaultFillDisabled,
  rail: globalTheme.color.backgroundSliderDefaultTrackEnabled,
  railDisabled: globalTheme.color.backgroundSliderDefaultTrackDisabled,
  handleDiameter: globalTheme.sizing.dimensionXxsmall,
  trackHeight: '0.4rem',
  railHeight: '0.2rem',
  radius: globalTheme.sizing.borderRadiusXsmall,
};

const cssVariable = {
  accentColor: `--tui-slider-accent-color`,
};

const container = css`
  position: relative;
`;

const labels = css`
  display: flex;
  justify-content: space-between;
  font-size: ${theme.fontSize};
  line-height: ${theme.lineHeight};
  color: ${theme.value};
  font-weight: ${theme.fontWeight};
  font-family: ${theme.fontFamily};
  cursor: default;
  label {
    color: ${theme.label};
  }
`;

const wrapper = css`
  position: inherit;
  cursor: pointer;
  .${container}[data-disabled] & {
    cursor: default;
  }
`;

const touchArea = css`
  height: 48px;
`;

const rails = css`
  position: absolute;
  width: 100%;
  height: ${theme.railHeight};
  border-radius: ${theme.radius};
  background-color: ${theme.rail};
  top: calc(50% - ${theme.railHeight} / 2);
  .${container}[data-disabled] & {
    background-color: ${theme.railDisabled};
  }
`;

const handleWrapper = css`
  position: absolute;
  top: 0;
  right: calc(${theme.handleDiameter} / 2);
  bottom: 0;
  left: calc(${theme.handleDiameter} / 2);
  pointer-events: none;
`;

const handle = css`
  position: absolute;
  width: ${theme.handleDiameter};
  height: ${theme.handleDiameter};
  margin-left: calc(0% - ${theme.handleDiameter} / 2);
  cursor: pointer;
  top: calc(50% - ${theme.handleDiameter} / 2);
  border: 1px solid ${theme.handleBorder};
  border-radius: 100%;
  background-color: ${theme.handle};
  touch-action: none;
  pointer-events: all;
  .${container}[data-disabled] & {
    cursor: default;
    background-color: ${theme.handleDisabled};
    border: 1px solid ${theme.handleBorderDisabled};
  }
  &:active {
    border: 1px solid var(${cssVariable.accentColor}, ${theme.hover});
    box-shadow: inset 1px ${theme.handleDiameter} ${theme.fill};
  }
  &:hover {
    border: 1px solid var(${cssVariable.accentColor}, ${theme.hover});
  }
`;

const focus = css`
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  overflow: hidden;
  opacity: 0;
  margin: -4px;
  box-shadow: 0 0 0 2px ${theme.focus};
  border-radius: 50%;
  .${handle}[data-focused] & {
    opacity: 1;
  }
`;

const track = css`
  position: absolute;
  height: ${theme.trackHeight};
  background-color: var(${cssVariable.accentColor}, ${theme.track});
  border-radius: ${theme.radius};
  display: flex;
  top: calc(50% - ${theme.trackHeight} / 2);
  .${container}[data-disabled] & {
    background-color: ${theme.trackDisabled};
  }
`;

const styles = {
  labels,
  rails,
  track,
  handle,
  handleWrapper,
  wrapper,
  focus,
  container,
  touchArea,
};

export default styles;
